import { FETCH_MIPS_START, FETCH_MIPS_SUCCESS, FETCH_MIPS_ERROR, ADD_MIP_SUCCESS, ADD_MIP_ERROR, UPDATE_MIP_SUCCESS, UPDATE_MIP_ERROR} from '../../actions/admin/mipsAction';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    mips: []
};

const mipsReducer = (state = INIT_STATE, action) => {
    let newState;
    let newMips;
    let index;
    switch (action.type) {
        case FETCH_MIPS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_MIPS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, mips: action.mips };
        }
        case FETCH_MIPS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case ADD_MIP_SUCCESS: {
            newState = {...state}
            newMips = [...newState.mips];
            newMips.push(action.mip);
            newState.mips = [...newMips];
            return newState;
        }
        case ADD_MIP_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case UPDATE_MIP_SUCCESS:{
            newState = {...state}
            newMips = [...newState.mips];
            index = newMips.findIndex(mip=> mip.mipId === action.mip.mipId);
            if(index > -1){
                newMips.splice(index, 1, action.mip);
            }
            newState.mips = [...newMips];
            return newState;
        }
        case UPDATE_MIP_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        default:
            return state;
    }
}

export default mipsReducer;
